import script from "./AudienceHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceHeader.vue?vue&type=style&index=0&id=e3a39c6e&lang=scss"

const __exports__ = script;

export default __exports__